/**
 * Created By Elia Rohana on 1/13/19
 */
import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import { PathwaysModeling } from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';

export class NodeResetDataHandler implements CommandHandler {


    constructor(private pathwaysModeling: PathwaysModeling) {
    }

    preExecute(context): any {
        this.pathwaysModeling.clearNodeData(context.element);
    }


    postExecute(context): any {
      this.pathwaysModeling.updateNodeData(context.element, context.nodeCreationResult, context.nodeType, context.ignoreTrackingChange);
    }


}
